import { useQuery } from '@tanstack/react-query';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import { tagsApiQueryKeys } from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

const useGetTargetTags = (targetType: TaggableType, targetId: string) => {
  return useQuery({
    queryKey: tagsApiQueryKeys.forTarget(targetType, targetId),
    queryFn: () => tagsApi.getForTarget(targetType, targetId),
    enabled: !!targetId,
  });
};

export default useGetTargetTags;
